export default {"src":"/pro/_next/static/media/vertex-monochrome-icon.c56a8230.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};